import publicApiCall from '../../utils/publicAxiosCall2';
import AxiosCall from '../../utils/axiosCall';
import { errorToast, successToast } from '../../utils/toast';
import { setPopup, togglePopup } from '../popup/popUpReducer';
import { setAccessToken, setUser } from './userReducer';
const baseURL = `${process.env.NEXT_PUBLIC_BASE_URL_DEV}/api`;

// export const userLogin =
//   (user, navigate, setOpen, setSearchParams) => (dispatch) => {
//     console.log("user coming is",user);
//     publicApiCall
//       .post('/user/login', user)
//       .then((res) => {
//         if (res.data.success && res.status === 200) {
//           console.log("success");
//           const lastLogin = new Date(res.data.data.lastLoginAt)
//           const validateLogin = new Date("2000-01-01")
//           if (lastLogin < validateLogin) {
//             dispatch(setPopup(true))
//           }
//           dispatch(setUser(res.data));
//           dispatch(setAccessToken(res.data.accessToken));
//           localStorage.setItem('accessToken', res.data.accessToken);
//           navigate();
//           successToast(res.data.message);
//         } else {
//           if (res.status === 202) {
//             console.log("error");
//             setSearchParams({
//               success: false,
//               tempToken: res.data?.tempToken,
//             });
//           }
//         }
//       })
//       .catch((err) => {
//         console.log("error = "+err
//           // err.response.data.message
//           //   ?.toLowerCase()
//           //   .includes('email not verified')
//         );
//         if (
//           err.response.data.message
//             ?.toLowerCase()
//             .includes('email not verified')
//         ) {
//           setOpen(true);
//         } else {
//           errorToast(err.response.data.message);
//         }
//       });
//   };
// import { baseURL } from '../../utils/publicAxiosCall2';
// import { errorToast, successToast } from '../../utils/toast';
// import { setPopup, setUser } from './userReducer';

// export const userLogin = (user, navigate, setOpen, setSearchParams) => async (dispatch) => {
//   console.log("user coming is", user);

//   try {
//     const res = await fetch(`${baseURL}/user/login`, {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(user),
//     });

//     console.log(res);
//     if (!res.ok) {
//       const data = await res.json(); // Parse the response JSON

//       console.log("data from error is ",data);
//      // throw new Error(`HTTP error! Status: ${res.status}`);
//     }

//     const data = await res.json(); // Parse the response JSON

//     console.log(data);
//     if (res.data.success && res.status === 200) {
//       console.log("success");
//       const lastLogin = new Date(res.data.data.lastLoginAt)
//       const validateLogin = new Date("2000-01-01")
//       if (lastLogin < validateLogin) {
//         dispatch(setPopup(true))
//       }
//       dispatch(setUser(res.data));
//       dispatch(setAccessToken(res.data.accessToken));
//       localStorage.setItem('accessToken', res.data.accessToken);
//       navigate();
//       successToast(res.data.message);
//     } else {
//       if (res.status === 202) {
//         console.log("error");
//         setSearchParams({
//           success: false,
//           tempToken: res.data?.tempToken,
//         });
//       }
//     }
//     // Handle the response data
//     console.log('Success:', data);
//     if (
//       res.data.message
//         ?.toLowerCase()
//         .includes('email not verified')
//     ) {
//       setOpen(true);
//     } else {
//       errorToast(res.data.message);
//     }
//     // Additional dispatch or handling logic if needed
//   } catch (err) {
//     // Handle errors

//     console.error('Error:', err);
//   }
// };

export const userLogin = (user, navigate, setOpen, setSearchParams) => async (dispatch) => {
  console.log("user is ", user);
  // document.querySelector('.overlay').style.display = 'block';
  document.getElementById('overlay').style.display = 'block';

  var response = null;
  var res = null;
  try {
    response = await fetch(`${baseURL}/user/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    res = await response.json();
    document.getElementById('overlay').style.display = 'none';

    if (res.success && response.status === 200) {
      const lastLogin = new Date(res.data.lastLoginAt);
      const validateLogin = new Date("2000-01-01");

      if (lastLogin < validateLogin) {
        dispatch(setPopup(true));
      }

      dispatch(setUser(res));
      //const user1 = useSelector(state => state.user?.user);
      // console.log("user from dispatch is ",user1);
      dispatch(setAccessToken(res.accessToken));
      localStorage.setItem('accessToken', res.accessToken);

      navigate();

      console.log("res is ", res);
      successToast(res.message);
    } else {
      if (response.status === 202) {
        setSearchParams({
          success: false,
          tempToken: res?.tempToken,
        });
      }
    }
  } catch (err) {
    document.getElementById('overlay').style.display = 'none';

    //const res = await response.json();

    console.log(
      err.message.toLowerCase().includes('email not verified')
    );

    if (err.message.toLowerCase().includes('email not verified')) {
      setOpen(true);
    } else {
      console.log("error is this ", err);
      errorToast(res.message);
    }
  }
};

export const getUserDetail = () => (dispatch) => {
  AxiosCall.get('/user/dashboard/info')
    .then((res) => {
      if (res.data.success) {
        dispatch(setUser(res.data));
      }
    })
    .catch((err) => {
      errorToast(err.response.data.message);
    });
};

export const userLoginGoogle = () => (dispatch) => {
  window.open(`${baseURL}/user/auth/google`, '_self');
};
export const userLoginFacebook = () => (dispatch) => {
  window.open(`${baseURL}/user/auth/facebook`, '_self');
};

export const userRegister = (user, navigate) => async (dispatch) => {
  var response = null;
  document.getElementById('overlay').style.display = 'block';
  console.log("user = ", user);
  try {
    response = await fetch(`${baseURL}/user/register`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(user),
    });

    const res = await response.json();
    console.log("res = ", res);
    // if (!response.ok) {
    //   errorToast(res.message);

    //   // throw new Error(`HTTP error! Status: ${response.status}`);
    // }



    if (response.ok && res.success) {
      successToast(res.message);
      navigate('/sign-in');
    } else {
      document.getElementById('overlay').style.display = 'none';
      errorToast(res.message);
    }
  } catch (err) {
    document.getElementById('overlay').style.display = 'none';
    console.log(err);
    // const res = await response.json();
    //errorToast("some thing wrong");


  }
  // publicApiCall
  //   .post('/user/register', user)
  //   .then((res) => {
  //     if (res.data.success) {
  //       successToast(res.data.message);
  //       navigate('/login');
  //     } else {
  //       errorToast(res.data.message);
  //     }
  //   })
  //   .catch((err) => {
  //     errorToast(err.response.data.message);
  //   });
};
export const userRegisterPhone = (user, navigate) => (dispatch) => {
  publicApiCall
    .post('/user/register/phone', user)
    .then((res) => {
      if (res.data.success) {
        successToast(res.data.message);
        navigate(`/phone/verification-code/${res.data.verificationToken}`);
      } else {
        errorToast(res.data.message);
      }
    })
    .catch((err) => {
      errorToast(err.response.data.message);
    });
};
export const userVerifyPhone =
  (verificationToken, otp, navigate) => (dispatch) => {
    publicApiCall
      .post(
        '/user/verify-phone',
        {
          otp,
        },
        {
          headers: {
            Authorization: verificationToken,
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          successToast(res.data.message);
          navigate('/login');
        } else {
          errorToast(res.data.message);
        }
      })
      .catch((err) => {
        errorToast(err.response.data.message);
      });
  };
